function normalizeValue(value) {
  return String(value || '').trim().toLowerCase()
}

function resolveEnvironmentLabel({ env, nodeEnv } = {}) {
  const buildEnv = normalizeValue(env)
  const runtimeEnv = normalizeValue(nodeEnv)
  const effectiveEnv = buildEnv || runtimeEnv

  if (!effectiveEnv || effectiveEnv === 'production' || effectiveEnv === 'prd') {
    return ''
  }
  if (effectiveEnv === 'development') {
    return 'dev'
  }
  return 'test'
}

function resolveEnvironmentBadge({ appVersion, env, nodeEnv } = {}) {
  const version = String(appVersion || '').trim()
  const label = resolveEnvironmentLabel({ env, nodeEnv })

  if (!version || !label) {
    return {
      visible: false,
      label: '',
      text: ''
    }
  }

  return {
    visible: true,
    label,
    text: `v${version} · ${label}`
  }
}

module.exports = {
  resolveEnvironmentBadge,
  resolveEnvironmentLabel
}
